/* eslint-disable no-param-reassign */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { DropdownSelectField, Icon } from '@jutro/legacy/components';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { Link } from '@jutro/router';
import styles from './RevenueTableComponent.module.scss';
import metadata from './RevenueTableComponent.metadata.json5';
import { TranslatorContext } from '@jutro/legacy/locale';

function RevenueTableComponent(props) {

    const {
        data: RevenueTableVM,
        updateWizardData,
        submissionVM,
        RevenueTablePath
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);

    const addRevenueTable = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            RevenueTableVM.value = RevenueTableVM.value || []

            const { _xCenter, _dtoName } = RevenueTableVM;

            const RevenueTableObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            RevenueTableVM.pushElement(
                RevenueTableObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, RevenueTableVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            RevenueTableVM.value.splice(index, 1);
            _.set(submissionVM.value, RevenueTablePath, RevenueTableVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, RevenueTablePath, RevenueTableVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;

            if (path === 'groRev1') {
                const value = (item && item.groRev1) ? item.groRev1 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = RevenueTableVM.length > 0 && RevenueTableVM.children[index].groRev1
                    // eslint-disable-next-line security/detect-object-injection
                    ? RevenueTableVM.children[index].groRev1.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.groRev1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                        readOnly
                    />
                );
            }

            if (path === 'a12MonExp') {
                const value = item.a12MonExp ? item.a12MonExp : '';

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            if (val.amount === '-' || val.amount < 0) return;
                            item.a12MonExp = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'a12MonPri') {
                const value = item.a12MonPri ? item.a12MonPri : '';

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            if (val.amount === '-' || val.amount < 0) return;
                            item.a12MonPri = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'nex12MonAnt4') {
                const value = item.nex12MonAnt4 ? item.nex12MonAnt4 : '';

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            if (val.amount === '-' || val.amount < 0) return;
                            item.nex12MonAnt4 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

        }, [handleValueChange, translator, RevenueTableVM])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const getTotala12MonExp = () => {
        let total = 0;

        _.each(RevenueTableVM.value, (val) => {
            if (!_.isString(val.a12MonExp.amount)) {
                total += val.a12MonExp.amount;
            }
        });

        return total;
    };

    const getTotala12MonPri = () => {
        let total = 0;

        _.each(RevenueTableVM.value, (val) => {
            if (!_.isString(val.a12MonPri.amount)) {
                total += val.a12MonPri.amount;
            }
        });

        return total;
    };


    const getTotalnex12MonAnt4 = () => {
        let total = 0;

        _.each(RevenueTableVM.value, (val) => {
            if (!_.isString(val.nex12MonAnt4.amount)) {
                total += val.nex12MonAnt4.amount;
            }
        });

        return total;
    };

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`RevenueTableTable`]: {
            data: RevenueTableVM.value,
        },
        totStaAToF11: {
            value: getTotala12MonExp(),
            readOnly: true
        },
        totStaAToF12: {
            value: getTotala12MonPri(),
            readOnly: true
        },
        totStaAToF13: {
            value: getTotalnex12MonAnt4(),
            readOnly: true
        }

    }), [RevenueTableVM?.value, getTotala12MonExp, getTotala12MonPri, getTotalnex12MonAnt4])

    const resolvers = {
        resolveCallbackMap: {
            addRevenueTable,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            RevenueTableVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [RevenueTableVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={RevenueTableVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

RevenueTableComponent.propTypes = wizardProps;
export default withRouter(RevenueTableComponent);
